import { axiosInstance } from './api';

export interface ExportParams {
  dateFrom?: string;
  dateTo?: string;
  userName?: string;
  districtName?: string;
  officeName?: string;
}

export const exportApi = {
  participants: async (
    eventId: number,
    params: ExportParams
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axiosInstance.get<Blob>(
      `/export/leaderboard-events/${eventId}/participants`,
      {
        params: {
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          userName: params.userName,
        },
        responseType: 'blob',
        headers: { Accept: '*/*' },
      }
    );

    const contentDisposition = (response.headers as any)['content-disposition'] as
      | string
      | undefined;
    const filename =
      contentDisposition?.split('filename=')[1]?.replace(/["']/g, '') ||
      `participants_export_${new Date().toISOString().split('T')[0]}.xlsx`;

    return { blob: response.data, filename };
  },

  districts: async (
    eventId: number,
    params: ExportParams
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axiosInstance.get<Blob>(
      `/export/leaderboard-events/${eventId}/districts`,
      {
        params: {
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          districtName: params.districtName,
        },
        responseType: 'blob',
        headers: { Accept: '*/*' },
      }
    );

    const contentDisposition = (response.headers as any)['content-disposition'] as
      | string
      | undefined;
    const filename =
      contentDisposition?.split('filename=')[1]?.replace(/["']/g, '') ||
      `districts_export_${new Date().toISOString().split('T')[0]}.xlsx`;

    return { blob: response.data, filename };
  },

  offices: async (
    eventId: number,
    params: ExportParams
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axiosInstance.get<Blob>(
      `/export/leaderboard-events/${eventId}/offices`,
      {
        params: {
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          officeName: params.officeName,
        },
        responseType: 'blob',
        headers: { Accept: '*/*' },
      }
    );

    const contentDisposition = (response.headers as any)['content-disposition'] as
      | string
      | undefined;
    const filename =
      contentDisposition?.split('filename=')[1]?.replace(/["']/g, '') ||
      `offices_export_${new Date().toISOString().split('T')[0]}.xlsx`;

    return { blob: response.data, filename };
  },

  participantClients: async (
    eventId: number,
    participantId: number
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axiosInstance.get<Blob>(
      `/export/leaderboard-events/${eventId}/participants/${participantId}/clients`,
      {
        responseType: 'blob',
        headers: { Accept: '*/*' },
      }
    );

    const contentDisposition = (response.headers as any)['content-disposition'] as
      | string
      | undefined;
    const filename =
      contentDisposition?.split('filename=')[1]?.replace(/["']/g, '') ||
      `participant_clients_export_${new Date().toISOString().split('T')[0]}.xlsx`;

    return { blob: response.data, filename };
  },

  participantReviews: async (
    eventId: number,
    participantId: number
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axiosInstance.get<Blob>(
      `/export/leaderboard-events/${eventId}/participants/${participantId}/reviews`,
      {
        responseType: 'blob',
        headers: { Accept: '*/*' },
      }
    );

    const contentDisposition = (response.headers as any)['content-disposition'] as
      | string
      | undefined;
    const filename =
      contentDisposition?.split('filename=')[1]?.replace(/["']/g, '') ||
      `participant_reviews_export_${new Date().toISOString().split('T')[0]}.xlsx`;

    return { blob: response.data, filename };
  },
};
